import { observable, action, makeObservable } from 'mobx';
import moment from 'moment/min/moment-with-locales';
import _ from 'lodash';
import agent from '../agent';


let addressThrottleTimer = null;

class ClientStore {
    constructor() {
        makeObservable(this, {
            currentList: observable,
            currentEntity: observable,
            availableActiveTaskInClient: observable,
            updatingErrors: observable,
            updating: observable,
            loading: observable,
            requestParams: observable,
            deleteSuccess: observable,
            lastListLoadTime: observable,
            filters: observable,
            appliedFilters: observable,
            holidayList: observable,
            setLoading: action,
            setFilter: action,
            onFilter: action,
            resetLastListLoadTime: action,
            loadList: action,
            returnDefaultNew: action,
            load: action,
            save: action,
            setDefaultDataForTip: action,
            getMultipleAttachments: action,
            addAttachments: action,
            renewClient: action,
            remove: action,
            getmultipleAccountsForClient: action,
            checkIfGroupInUse: action,
            resetClientData: action,
            performRecalcGpsForClient: action,
            recalcGpsForClient: action,
            getActiveTaskWithMembersForExtraPayments: action,
            getCompanyShift: action,
            getCompanyShiftById: action,
            saveCompanyShift: action,
            editCompanyShift: action,
            deleteCompanyShift: action,
            getOvertimeSetting: action,
            saveOvertimeSetting: action,
            editOvertimeSetting: action,
            deleteOvertimeSetting: action,
            saveCompanyShiftOvertime: action,
            updateCompanyShiftOvertime: action,
            deleteCompanyShiftOvertime: action,
            saveXledgerDetails: action,
            grantClientApiAccess: action,
            revokeClientAPIAccess: action,
            getClientApiKeys: action,
            regenerateClientApiKey: action,
            saveHolidays: action,
            saveRecommendedHolidays: action,
            getHolidayList: action,
            getHolidays: action,
            getRecommendedHolidays: action,
            deleteHoliday: action,
            validateClientRuleChange: action,
            updateVacationTypes: action,
            addAppVersion: action,
            getAppVersions: action,
            deleteAppVersion: action,
            saveIntegrationSettings: action,
            getWeeklyOvertimeSettings: action,
            getWeeklyOvertimeSettingById: action,
            saveWeeklyOvertimeSetting: action,
            updateWeeklyOvertimeSetting: action,
            activationWeeklyOvertimeSetting: action,
            deleteWeeklyOvertimeMap: action,
            saveWeeklyOvertimeMap: action,
            updateWeeklyOvertimeMap: action,
            getOvertimeCapSettings: action,
            getOvertimeCapSettingById: action,
            saveOvertimeCapSetting: action,
            updateOvertimeCapSetting: action,
            activationOvertimeCapSetting: action,
            importFromExcel: action,
            importTimesheetFromExcel: action
        });
    }

    currentList = [];
    currentEntity = {};
    availableActiveTaskInClient = [];
    companyShift = [];
    overtimeSettingList = [];
    workHoursRule = [];
    updatingErrors = null;
    updating = false;
    loading = false;
    requestParams = {};
    deleteSuccess = false;
    lastListLoadTime = null;
    filters = {
        biztype: '',
        name: '',
        status: 'active'
    };
    appliedFilters = {
        biztype: '',
        name: '',
        status: 'active'
    };
    holidayList = [];
    validateClientRuleChangeResponse = {
        socialWelfare: {
            maxSocialWelfareHoursUsed: 0,
            usedSocialWelfareLeaveTypes: []
        },
        collectiveAgreement: {
            maxCollectiveAgreementLeaveDaysUsed: 0
        }
    };

    setLoading(value) {
        this.loading = value;
    }

    setFilter(name, value) {
        const filters = Object.assign({}, this.filters);
        filters[name] = value;
        this.filters = filters;
    }

    onFilter() {
        this.appliedFilters = Object.assign({}, this.filters);
    }

    resetLastListLoadTime() {
        this.lastListLoadTime = new Date();
    }

    resetClientData(data) {
        this.currentEntity.client.data = data
    }

    loadList(params) {
        this.loading = true;
        return agent.Clients.list(params)
            .then(
                action(list => {
                    this.requestParams = params;
                    list.time = new Date();
                    this.currentList = list;
                    this.lastListLoadTime = list.time;
                    this.loading = false;
                    return list;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    returnDefaultNew(params) {
        this.currentEntity = {
            client: {
                User: { data: {} },
                data: {},
                max_users: 1000,
                renew_manual: true,
                biztype: 1,
                renew_date: moment(new Date()).add(1, 'years').toISOString(),
                ...params,
            },
        };
        this.loading = false;

        return this.currentEntity;
    }

    load(id) {
        this.loading = true;
        return agent.Clients.load(id)
            .then(
                action(response => {
                    if (!response.client.User) response.client.User = {};
                    if (!response.client.data) response.client.data = {};
                    if (!response.client.User.data) response.client.User.data = {};
                    this.currentEntity = response;
                    this.setDefaultDataForTip();
                    this.loading = false;
                    return response;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    update2FASettings(data) {
        return agent.Clients.update2FASettings(data);
    }

    save(values, isAdd) {
        this.updating = true;
        return agent.Clients.save(values, isAdd)
            .then(
                action(user => {
                    this.currentEntity = user;
                    this.setDefaultDataForTip()
                    return user;
                })
            )
            .catch(
                action(err => {
                    this.updating = false;
                    this.updatingErrors = err.response && err.response.body && err.response.body.errors;
                    throw err;
                })
            );
    }

    setDefaultDataForTip() {
        if (!this.currentEntity.client.data.tipRules && this.currentEntity.client.allow_tip) {
            this.currentEntity.client.data.tipRules = {
                tipEditor: "pm",
                tipAllocation: "selected",
                profiles: [
                    {
                        employee_type: "waiter",
                        percentage: 70
                    },
                    {
                        employee_type: "cook",
                        percentage: 30
                    }
                ]
            }
        }
    }

    getMultipleAttachments(data) {
        return agent.Clients.getMultipleAttachments(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    addAttachments(data) {
        return agent.Clients.addAttachments(data)
            .then(
                action((response) => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    renewClient(data) {
        return agent.Clients.renewClient(data)
            .then(
                action((response) => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getTripleTexToken(data) {
        return agent.Clients.getTripleTexToken(this.currentEntity.client.id, data)
            .then(
                action((response) => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getmultipleAccountsForClient(id) {
        return agent.Clients.getmultipleAccountsForClient(id)
            .then(
                action((response) => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveVismaDetails(data) {
        return agent.Clients.saveVismaDetails(data)
            .then(
                action((response) => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    checkIfGroupInUse(code) {
        return agent.UserGroups.checkIfGroupInUse(code)
            .then(
                action((response) => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }


    async remove(id) {
        await agent.Clients.remove(id);
        this.lastListLoadTime = new Date();
        this.deleteSuccess = true;
        return 1;
    }

    async performRecalcGpsForClient(newAddress) {
        this.gpsNowLoading = true;
        this.currentEntity.client.data.addressCache = newAddress;
        const tsk = _.cloneDeep(this.currentEntity.client);
        try {
            const data = await agent.Tasks.gpsAddress(newAddress, null, false);
            tsk.gps_data = data.result;
            tsk.data.addressCache = newAddress;
            this.currentEntity = { client: tsk };
            this.gpsNowLoading = false;
        } catch (e) {
            this.gpsNowLoading = false;
            throw e;
        }
    }



    async recalcGpsForClient(changes) {
        const entityToAddressString = e => {
            return `${e.address}, ${e.post_place}, ${e.post_number}`;
        };

        if (!changes.address || !changes.post_place) {
            return changes;
        }

        const newAddress = entityToAddressString(changes);

        if (newAddress === this.currentEntity.client.data.addressCache) return changes;

        addressThrottleTimer = new Date().getTime();
        setTimeout(() => {
            if (new Date().getTime() - addressThrottleTimer < 1000) {
                return;
            }
            if (this.currentEntity.client.data.addressCache === newAddress) {
                return;
            }
            this.performRecalcGpsForClient(newAddress);
        }, 1000);
        return changes;
    }

    getActiveTaskWithMembersForExtraPayments() {
        return agent.Clients.getActiveTaskWithMembersForExtraPayments()
            .then(
                action(response => {
                    this.availableActiveTaskInClient = response.tasks;
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getCompanyShift() {
        return agent.Clients.getCompanyShift()
            .then(
                action(response => {
                    this.companyShift = response.companyShift;
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getCompanyShiftById(id) {
        return agent.Clients.getCompanyShiftById(id)
            .then(
                action(response => {
                    this.companyShift = response.companyShift;
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveCompanyShift(data) {
        return agent.Clients.saveCompanyShift(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    editCompanyShift(id, data) {
        return agent.Clients.editCompanyShift(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    deleteCompanyShift(id) {
        return agent.Clients.deleteCompanyShift(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getOvertimeSetting() {
        return agent.Clients.getOvertimeSetting()
            .then(
                action(response => {
                    this.overtimeSettingList = response.overtimeSettingList || [];
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveOvertimeSetting(data) {
        return agent.Clients.saveOvertimeSetting(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    editOvertimeSetting(id, data) {
        return agent.Clients.editOvertimeSetting(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    deleteOvertimeSetting(id) {
        return agent.Clients.deleteOvertimeSetting(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveCompanyShiftOvertime(data) {
        return agent.Clients.saveCompanyShiftOvertime(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    updateCompanyShiftOvertime(id, data) {
        return agent.Clients.updateCompanyShiftOvertime(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    deleteCompanyShiftOvertime(id) {
        return agent.Clients.deleteCompanyShiftOvertime(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getWeeklyOvertimeSettings() {
        return agent.Clients.getWeeklyOvertimeSettings()
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getWeeklyOvertimeSettingById(id) {
        return agent.Clients.getWeeklyOvertimeSettingById(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveWeeklyOvertimeSetting(data) {
        return agent.Clients.saveWeeklyOvertimeSetting(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    updateWeeklyOvertimeSetting(id, data) {
        return agent.Clients.updateWeeklyOvertimeSetting(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }
    activationWeeklyOvertimeSetting(id, data) {
        return agent.Clients.activationWeeklyOvertimeSetting(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    deleteWeeklyOvertimeMap(id) {
        return agent.Clients.deleteWeeklyOvertimeMap(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveWeeklyOvertimeMap(data) {
        return agent.Clients.saveWeeklyOvertimeMap(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    updateWeeklyOvertimeMap(id, data) {
        return agent.Clients.updateWeeklyOvertimeMap(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getOvertimeCapSettings() {
        return agent.Clients.getOvertimeCapSettings()
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getOvertimeCapSettingById(id) {
        return agent.Clients.getOvertimeCapSettingById(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveOvertimeCapSetting(data) {
        return agent.Clients.saveOvertimeCapSetting(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    updateOvertimeCapSetting(id, data) {
        return agent.Clients.updateOvertimeCapSetting(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    activationOvertimeCapSetting(id, data) {
        return agent.Clients.activationOvertimeCapSetting(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }



    //Holiday calendar settings
    getHolidayList(params) {
        return agent.Clients.getHolidayList(params)
            .then(
                action(response => {
                    this.holidayList = response.rows;
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getHolidays(params) {
        return agent.Clients.getHolidays(params)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            )
    }

    getRecommendedHolidays(params) {
        return agent.Clients.getRecommendedHolidays(params)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            )
    }

    deleteHoliday(params) {
        return agent.Clients.deleteHoliday(params)
            .then(
                action(
                    response => {
                        return response;
                    }
                ))
            .catch(
                action(err => {
                    throw err;
                })
            )
    }

    saveHolidays(data) {
        return agent.Clients.saveHolidays(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            )
    }

    saveRecommendedHolidays(data) {
        return agent.Clients.saveRecommendedHolidays(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            )
    }

    // Api gateway Access functions
    grantClientApiAccess(clientId) {
        return agent.Clients.grantClientApiAccess(clientId)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    revokeClientAPIAccess(clientId) {
        return agent.Clients.revokeClientAPIAccess(clientId)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getClientApiKeys(clientId) {
        return agent.Clients.getClientApiKeys(clientId)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    regenerateClientApiKey() {
        return agent.Clients.regenerateClientApiKey()
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    // work hours setup functions
    getWorkHoursRule() {
        return agent.Clients.getWorkHoursRule()
            .then(
                action(response => {
                    this.workHoursRule = response.workHoursRule;
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getWorkHoursRuleById(id) {
        return agent.Clients.getWorkHoursRuleById(id)
            .then(
                action(response => {
                    this.workHoursRule = response.workHoursRule;
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveWorkHoursRule(data) {
        return agent.Clients.saveWorkHoursRule(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    validateClientRuleChange(data, module) {
        return agent.Clients.validateClientRuleChange(data, module)
            .then(
                action(response => {
                    this.validateClientRuleChangeResponse.socialWelfare.maxSocialWelfareHoursUsed = response.maxSocialWelfareHoursUsed;
                    this.validateClientRuleChangeResponse.socialWelfare.usedSocialWelfareLeaveTypes = response.usedSocialWelfareLeaveTypes;
                    this.validateClientRuleChangeResponse.collectiveAgreement.maxCollectiveAgreementLeaveDaysUsed = response.maxCollectiveAgreementLeaveDaysUsed;
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    editWorkHoursRule(id, data) {
        return agent.Clients.editWorkHoursRule(id, data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    deleteWorkHoursRule(id) {
        return agent.Clients.deleteWorkHoursRule(id)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getWorkHoursRuleByDepartment(department) {
        return agent.Clients.getWorkHoursRuleByDepartment(department)
            .then(
                action(response => {
                    this.workHoursRuleByDepartment = response.workHourRule;
                    return response.workHourRule;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    importFromExcel(params) {
        return agent.Clients.importFromExcel(params)
            .then(
                action(res => {
                    this.loading = false;
                    return res;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    importTimesheetFromExcel(data) {
        return agent.Clients.importTimesheetFromExcel(data)
            .then(
                action(res => {
                    this.loading = false;
                    return res;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    checkSameFileExists(params) {
        return agent.Clients.checkSameFileExists(params)
            .then(
                action(res => {
                    this.loading = false;
                    return res;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    updateVacationTypes(vacation_types) {
        this.currentEntity.client.data.extendedRules['vacation_types'] = vacation_types;
    }

    addAppVersion(data) {
        this.loading = true;
        return agent.Clients.addAppVersions(data)
            .then(
                action(
                    res => {
                        this.loading = false;
                        return res;
                    }
                )
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            )
    }

    getAppVersions(params) {
        this.loading = true;
        return agent.Clients.getAppVersions(params)
            .then(
                action(
                    res => {
                        res.time = new Date();
                        this.lastListLoadTime = res.time;
                        this.loading = false;
                        return res;
                    }
                )
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            )
    }

    deleteAppVersion(id) {
        this.loading = true;
        return agent.Clients.deleteAppVersion(id)
            .then(
                action(
                    res => {
                        this.loading = false;
                        return res;
                    }
                )
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            )
    }

    saveIntegrationSettings(id, data) {
        return agent.Clients.saveIntegrationSettings(id, data)
            .then(
                action(res => {
                    return res;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveXledgerDetails(data) {
        return agent.Clients.saveXledgerDetails(data)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getAdditionalPaymentTasks(additionalPaymentCode) {
        return agent.Clients.getAdditionalPaymentTasks(additionalPaymentCode)
            .then(
                action(response => {
                    return response;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }
}

const _ClientStore = new ClientStore();
export default _ClientStore;
